import ListCustomers from "../../../../components/@groups/customers/ListCustomers";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function CustomerGroupsPage() {

    return (
        <ListCustomers 
            routeType={routeTypes.admin}
        />
    )
}       